import React from "react";

const Support = () => {
    return (
        <div className="support-container">
            <h1>support</h1>
            <p>hello</p>
            <article>hello artical</article>
        </div>
    );
};

export default Support;
